import { render, staticRenderFns } from "./VisualizarDadosAluno.vue?vue&type=template&id=ed8f0962&"
import script from "./VisualizarDadosAluno.vue?vue&type=script&lang=js&"
export * from "./VisualizarDadosAluno.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarDadosAluno.vue?vue&type=style&index=0&id=ed8f0962&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports